import React, { useCallback, useEffect, useRef, memo } from "react";
import { useTheme } from "../../../core/contexts/ThemeContext";
import { useAuth } from "../../../core/contexts/AuthContext";
import NavItem from "./NavItem/NavItem";
import UserDetail from "./Common/UserDetail";

import { useRecoilState } from 'recoil';
import { vehicleSearchTypeState, vehicleSearchStrState } from '../../Common/Store/VehicleSearchStore';
import cookie from "react-cookies";
import { debounce } from "lodash";

//import "../../../wdyr";

const MapHeaderitem = [
  {
    Name: "All",
    vehicleType: "0",
    NavImage: "",
    isRuc: true,
  },
  {
    Name: "GateReader",
    vehicleType: "7",
    NavImage: "/assets/img/truck.png",
    isRuc: true,
  },
  {
    Name: "Assets",
    vehicleType: "3",
    NavImage: "/assets/img/petrol-vehicle.png",
    isRuc: true,
  },
];

const MapHeader = (props) => {
  //console.log("MapHeader.start");
  const { isOnlyRuc, } = props;

  const { authTokens } = useAuth();
  const { rucmonkeyTheme } = useTheme();

  const [vehicleType, setVehicleType] = useRecoilState(vehicleSearchTypeState);
  const [vehicleSearchStr, setVehicleSearchStr] = useRecoilState(vehicleSearchStrState);

  const menuBarRef = useRef();

  useEffect(() => {

    if (vehicleType === "") {

      //When parameter is not existing, check if existing the personalize setting
      if (cookie.load("gatereder.locate.vehicleType." + authTokens.user_name) !== undefined) {
        setVehicleType(cookie.load("gatereder.locate.vehicleType." + authTokens.user_name));
      } else {
        setVehicleType("0");
      }
    }

    if (vehicleSearchStr === "") {
      if (cookie.load("gatereder.locate.vehicleSearchStr." + authTokens.user_name) !== undefined) {
        setVehicleSearchStr(cookie.load("gatereder.locate.vehicleSearchStr." + authTokens.user_name));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const saveVehicleSearchStrCookie = useCallback(
    debounce((str) => {
      const expires = new Date();
      expires.setTime(expires.getTime() + 100 * 86400000);
      cookie.save("locate.vehicleSearchStr." + authTokens.user_name, str, { path: "/", expires });
    }, 500)
    , [authTokens.user_name]);


  const handleVehicleSearchStr = (str) => {

    setVehicleSearchStr(str);
    saveVehicleSearchStrCookie(str);

  };

  const onVehicleTypeClicked = (type) => {
    //console.log("vehicleType.type(state)", type);

    setVehicleType(type);
    setVehicleSearchStr("");
  };

  const onVehicleSearchClicked = (e) => {
    e.preventDefault();
  };



  const setVehicleFilter = () => {
    //
    return MapHeaderitem.map((item, i) => {
      //console.log("MapHeaderitem.map.item", item);
      if (!item.isRuc && isOnlyRuc) {
        //console.log("MapHeaderitem.map.hidden");
        return <React.Fragment key={-1} />;
      }

      return (
        <NavItem
          isActive={vehicleType === item.vehicleType}
          key={i}
          item={item}
          clicked={onVehicleTypeClicked}
        />
      );
    });
  };

  //if (!rucmonkeyTheme) return <div></div>;

  return (
    // <nav className="navbar navbar-expand-lg fixed-top navbar-transparent ">
    <nav
      className="navbar navbar-expand-lg fixed-top navbar-transparent navbar-height"
      style={rucmonkeyTheme ?? null}
    >
      <div className="container-fluid">
        <div className="navbar-wrapper">
          <div
            className="navbar-toggle nav-custom-bolck"
            style={{ display: "block" }}
          >
            <button
              type="button nav-custom-bolck"
              style={{ display: "block" }}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <div className=" no-border d-none d-sm-block">
            <form onSubmit={onVehicleSearchClicked}>
              <div className="input-group">
                <input
                  type="text"
                  onChange={(e) => handleVehicleSearchStr(e.target.value)}
                  value={vehicleSearchStr}
                  className="form-control"
                  placeholder="Search for a vehicle"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <i
                      className="nc-icon nc-zoom-split"
                      style={{ cursor: "pointer" }}
                      onClick={onVehicleSearchClicked}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <ul className="navbar-nav-map">{setVehicleFilter()}</ul>

        </div>

        <button
          ref={menuBarRef}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigation"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="nc-icon nc-minimal-down"></i>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navigation"
        >
          <div className="d-xs-block d-sm-none d-md-none d-lg-none">
            <form onSubmit={onVehicleSearchClicked}>
              <div className="input-group">
                <input
                  type="text"
                  onChange={(e) => handleVehicleSearchStr(e.target.value)}
                  value={vehicleSearchStr}
                  className="form-control"
                  placeholder="Search for a vehicle "
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <i
                      className="nc-icon nc-zoom-split"
                      style={{ cursor: "pointer" }}
                      onClick={onVehicleSearchClicked}
                    ></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <UserDetail />
        </div>
      </div>
    </nav>
  );
};

export default memo(MapHeader);
